import { Body1, Button, Card, Link, makeStyles, tokens } from '@fluentui/react-components';
import {
  accessOutsideOfTeams,
  accessOutsideOfTeamsLink,
  auContact,
  contactSupport,
  contactSupportLink,
  getInTouchLink,
  nzContact,
  registerMessage,
  registerMessagePart2,
  tryAgainLink,
  ukContact,
  userErrorDescription,
} from './strings';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@auth/AuthContext';
import config from '@config/config';

export const CustomerError = () => {
  const user = useUser();
  const navigation = useNavigate();

  const retry = async () => {
    await user.refresh();
    navigation('/');
  };

  const styles = useStyles();
  return (
    <>
      <Card className={styles.customerError}>
        <Body1>{userErrorDescription}</Body1>
        <Body1>
          {accessOutsideOfTeams}
          <Link
            href={`https://teams.microsoft.com/l/entity/${config.teamsAppId}/index0`}
            target="_blank"
            rel="noreferrer"
          >
            {accessOutsideOfTeamsLink}
          </Link>
        </Body1>
        <Body1>
          {contactSupport}
          <Link
            href="https://www.groovnow.com/groov-customer-service"
            target="_blank"
            rel="noreferrer"
          >
            {contactSupportLink}
          </Link>
          {registerMessage}
          <Link href="https://www.groovnow.com/request-more-info" target="_blank" rel="noreferrer">
            {getInTouchLink}
          </Link>
          {registerMessagePart2}
          <Link href="tel:+44 7539 874207">{ukContact}</Link>,
          <Link href="tel:+61 2 8310 6320">{auContact}</Link> or
          <Link href="tel:+64 9 801 8029">{nzContact}</Link>.
        </Body1>
        <Body1>
          <Button
            className={styles.retryButton}
            disabled={user.isLoading}
            appearance="primary"
            onClick={retry}
          >
            {tryAgainLink}
          </Button>
        </Body1>
      </Card>
    </>
  );
};

const useStyles = makeStyles({
  title: {
    marginBottom: tokens.spacingVerticalS,
  },
  description: {
    maxWidth: '80%',
    marginBottom: tokens.spacingVerticalXXXL,
    '@media screen and (min-width: 768px)': { maxWidth: '66%' },
  },
  customerError: {
    borderRadius: tokens.borderRadiusXLarge,
  },
  retryButton: {
    marginTop: tokens.spacingVerticalM,
  },
});
